<template>
    <CustomTable
        :column-form="column_form"
        :tab="true"
        :hideBtnTable="true"
        :hidePagi="true"
    >
        <template v-slot:header>
            <tr>
                <th rowspan="3" style="text-align: center">STT</th>
                <th rowspan="3" style="text-align: center">Phòng GD&amp;ĐT</th>
                <th rowspan="3" style="text-align: center">Đơn vị</th>
                <th colspan="5" style="text-align: center">
                    Nhân sự chia theo chức vụ
                </th>
                <th colspan="7" style="text-align: center">
                    Nhân sự chia theo đảng viên
                </th>
            </tr>
            <tr>
                <th rowspan="2">Tổng số</th>
                <th rowspan="2">Hiệu trưởng</th>
                <th rowspan="2">Phó Hiệu trưởng</th>
                <th rowspan="2">Giáo viên</th>
                <th rowspan="2">Nhân viên</th>
                <th rowspan="2">Tổng số</th>
                <th rowspan="2">Hiệu trưởng</th>
                <th rowspan="2">Phó Hiệu trưởng</th>
                <th colspan="3">Giáo viên</th>
                <th rowspan="2">Nhân viên</th>
            </tr>
            <tr>
                <th rowspan="1">Tổng GV</th>
                <th rowspan="1">Trong đó: Tổ trưởng</th>
                <th rowspan="1">Trong đó: Tổ phó</th>
            </tr>
        </template>

        <template v-slot:body>
            <template v-if="tableData.length === 0">
                <tr>
                    <td colspan="50">Không có bản ghi nào.</td>
                </tr>
            </template>
            <tr v-for="(item, index) in tableData" :key="index">
                <td>
                    {{ (start / limit) * limit + index + 1 }}
                </td>
                <td class="text-left">{{ item.tenDonVi }}</td>
                <td class="text-left">{{ item.tenDonVi }}</td>
                <td>{{ item.tongCanBo }}</td>
                <td>{{ item.tongHieuTruong }}</td>
                <td>{{ item.tongHieuPho }}</td>
                <td>{{ item.tongGiaoVien }}</td>
                <td>{{ item.tongNhanVien }}</td>

                <td>{{ item.tongDangVien }}</td>
                <td>{{ item.DangVienHieuTruong }}</td>

                <td>{{ item.dangVienHieuPho }}</td>
                <td>{{ item.dangVienGiaoVien }}</td>
                <td>{{ item.dangVienToTruong }}</td>
                <td>{{ item.dangVienToPho }}</td>
                <td>{{ item.dangVienNhanVien }}</td>
            </tr>
        </template>
    </CustomTable>
</template>

<script>
import CustomTable from '@/components/CustomTable.vue'

export default {
    name: 'StaffStatisticsByPartyMembership',
    components: {
        CustomTable
    },
    props: {
        tableData: {
            type: Array,
            require: true
        },
        start: {
            type: Number,
            require: true
        },
        limit: {
            type: Number,
            require: true
        },
        column_form: {
            type: Number,
            require: true
        }
    },

    data() {
        return {}
    },

    methods: {},
    mounted() {},

    computed: {}
}
</script>

<style scoped>
.min-width {
    min-width: 150px;
}
</style>
